<template>
  <div class="px-4">
    <ais-instant-search
      v-if="algoliaClient && showSearch"
      :search-function="searchFunction"
      :search-client="algoliaClient"
      :stalled-search-delay="0"
      :index-name="algoliaIndex"
    >
      <!-- eslint-disable -->
      <ais-configure
        :hits-per-page.camel="10"
        :query="query"
        :page="0"
        :typoTolerance="true"
        :restrictSearchableAttributes="searchOnAtributes"
        :filters="filters"
      />
      <!-- eslint-enable -->
      <SearchManagerV2
        ref="searchManager"
        :force-renderer="forceRenderer"
      />
    </ais-instant-search>
  </div>
</template>
<script>

import SearchManagerV2 from '@/components/search/SearchManagerV2';

import { algoliaMixin } from '@/mixins';

export default {
  name: 'Search',
  components: { SearchManagerV2 },
  mixins: [algoliaMixin],
  beforeRouteLeave (to, from, next) {
    next();
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {

    });
  },
  beforeRouteUpdate (to, from, next) {
    next();
  },
  data () {
    return ({
      showSearch: true,
      fields: this.$store.state.advancedFieldSearchConfig
    });
  },
  computed: {
    searchFields () {
      const fields = [];
      Object.entries(this.$route.query).forEach(([key, value]) => {
        const fieldConfig = this.fields.find(field => field.field_name === key);
        if (fieldConfig) {
          const filteredValue = typeof value === 'string' ? value.trim() : value;
          fieldConfig.value = filteredValue;
          fields.push(fieldConfig);
        }
      });

      return fields;
    },
    searchOnAtributes () {
      const atributes = [];
      this.searchFields.forEach(field => {
        if (field.typo_tolerance) {
          if (field.facet) {
            atributes.push(field.facet);
          } else {
            atributes.push(field.field_name);
          }
        }
      });
      return atributes;
    },
    query () {
      let query = this.$route.query.query || '';

      this.searchFields.forEach(field => {
        if (field.typo_tolerance) {
          query += ` ${field.value}`;
        }
      });

      return query !== '' ? query : null;
    },
    filters () {
      let filters = `wtype:customer AND workspace:${this.$store.state.brand}`;

      this.searchFields.forEach(field => {
        if (!field.typo_tolerance) {
          let logic = '';
          if (field.facet) {
            if (Array.isArray(field.facet)) {
              field.facet.forEach(facetKey => {
                logic += `${logic !== '' ? ' OR ' : ''}${facetKey}:"${field.value}"`;
              });
              logic = `(${logic})`;
            } else {
              logic = `${field.facet}:"${field.value}"`;
            }
          } else {
            logic = `${field.field_name}:"${field.value}"`;

            if (field.field_name === 'mobilephone' || field.field_name === 'telephone') {
              logic += ` OR ${field.field_name}:"+33${field.value}"`;
            }
          }
          filters += ` AND ${logic}`;
        }
      });

      return filters;
    },
    routeQuery () {
      return this.$route.query;
    }
  },
  mounted () {
  },
  created () {

  },
  methods: {
    forceRenderer () {
      this.showSearch = false;

      this.$nextTick(() => {
        this.showSearch = true;
      });
    },
    searchFunction (helper) {
      const previousSearch = this.$store.state.search;

      // Current search
      this.$store.commit('setSearch', this.$route.query);

      if (JSON.stringify(previousSearch) === JSON.stringify(this.$route.query)) {
        helper.search();
      } else {
        this.$store.commit('setSearch', this.$route.query);

        helper.clearRefinements().search();
      }
    }
  }
};
</script>
